/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  activitiesInfoModal: {
    explanationModalState: false,
    matchModalState: false,
    rewardModalState: false,
    scenarioModalState: false,
    sideModalState: false,
    situationModalState: false,
    sortModalState: false,
    testModalState: false,
    theoryModalState: false,
  },
  activitiesSideContentState: 'articles',
  additionalExercisesState: 'scenarios',
  notifications: null,
};

export const activitiesSlice = createSlice({
  initialState,
  name: 'activitiesSlice',
  reducers: {
    readNotifications: (state, { payload }) => {
      if (state.notifications) {
        state.notifications[payload] = false;
      }
    },
    reset: () => initialState,
    setActivitiesInfoModalState: (state, { payload }) => {
      state.activitiesInfoModal[payload.modal] = payload.state;
    },
    setActivitiesSideContentState: (state, { payload }) => {
      state.activitiesSideContentState = payload;
    },
    setAdditionalExercisesState: (state, { payload }) => {
      state.additionalExercisesState = payload;
    },
    setNotifications: (state, { payload }) => {
      state.notifications = payload;
    },
  },
});

export const activitiesSlicePersistedReducer = persistReducer(
  {
    key: 'activitiesSlice',
    storage,
  },
  activitiesSlice.reducer
);
